import {
  ILocation,
  ILocationCreate,
  ILocationTable,
  IPagedData,
  IPagedSearch,
  TableStatus,
} from '@evencel/models';

export class GetLocation {
  public static readonly type = '[Location] GetLocation';
  constructor(public id: string) {}
}

export class ActivateLocation {
  public static readonly type = '[Location] ActivateLocation';
  constructor(public location: ILocationTable) {}
}

export class SearchLocations {
  public static readonly type = '[Location] SearchLocations';
  constructor(public data: IPagedSearch) {}
}

export class CreateLocation {
  public static readonly type = '[Location] SaveLocation';
  constructor(public location: ILocationCreate) {}
}

export class UpdateLocation {
  public static readonly type = '[Location] UpdateLocation';
  constructor(public location: ILocation) {}
}

export class DeleteLocation {
  public static readonly type = '[Location] DeleteLocation';
  constructor(public location: ILocationTable) {}
}

export class RestoreLocation {
  public static readonly type = '[Location] RestoreLocation';
  constructor(public location: ILocationTable) {}
}

export class GetLocationsResponse {
  public static readonly type = '[Location] GetLocationsResponse';
  constructor(
    public pagedData: IPagedData<ILocation>,
    public status: TableStatus
  ) {}
}

export class GetLocationResponse {
  public static readonly type = '[Location] GetLocationResponse';
  constructor(public location: ILocation) {}
}
